import shallowEqual from './shallow-equal.tsx';

function exactEqual(objA: object, objB: object) {
	return objA === objB;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
function areArgumentsEqual(propsMode: boolean, prev: IArguments, next: any) {
	if (prev === null || next === null || prev.length !== next.length) return false;

	// If propsMode and 2 arguments, means it is an input selector
	// and we check for shallow equality on 2nd one to optimise props
	if (propsMode && prev.length === 2) {
		return prev[0] === next[0] && shallowEqual(prev[1], next[1]);
	}

	for (let i = 0; i < prev.length; i++) {
		if (!exactEqual(prev[i], next[i])) return false;
	}

	return true;
}

/**
 * Tailor made memoisation
 */
// eslint-disable-next-line jira/import/no-anonymous-default-export, @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
export default function (resultFn: any, propsMode = false): any {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
	let lastArgs: any = [];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
	let lastResult: any;
	let calledOnce = false;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
	const result = function (this: any) {
		// eslint-disable-next-line prefer-rest-params -- PLEASE FIX THIS SUPPRESSION
		if (calledOnce && areArgumentsEqual(propsMode, arguments, lastArgs)) {
			return lastResult;
		}

		// eslint-disable-next-line prefer-rest-params -- PLEASE FIX THIS SUPPRESSION
		const nextResult = resultFn.apply(this, arguments);
		if (!propsMode && shallowEqual(nextResult, lastResult)) {
			return lastResult;
		}

		lastResult = nextResult;
		calledOnce = true;
		// eslint-disable-next-line prefer-rest-params -- PLEASE FIX THIS SUPPRESSION
		lastArgs = arguments;
		return lastResult;
	};

	return result;
}
